const WA = 'https://wa.me/5555996946460?text=Olá,%20vim%20pelo%20Google%20e%20quero%20agendar%20consulta';
const LOGO = '/img/logo1.png';

export default function FooterSection() {
  return (
    <footer className="bg-[#F5F5F0] border-t border-[#DDE0D7] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <img src={LOGO} alt="Dra. Mariangela Escobar" className="h-14 w-auto mb-4" />
            <p className="text-[#3A3A3A]/70 text-sm">
              Dra. Mariangela Escobar Gonçalves<br />
              Médica – CRM 63381
            </p>
          </div>
          <div>
            <h4 className="font-bold text-[#3A3A3A] text-base mb-4">Contato</h4>
            <div className="space-y-3 text-[#3A3A3A]/70 text-sm">
              <p className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-2-line text-[#6B705C]"></i>
                </span>
                <span>São Borja – RS, Brasil</span>
              </p>
              <a
                href={WA}
                onClick={(e) => {
                  e.preventDefault();

                  if (typeof gtag_report_conversion === 'function') {
                    gtag_report_conversion(WA);
                  } else {
                    window.open(WA, '_blank');
                  }
                }}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#6B705C] transition-colors"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-[#6B705C]"></i>
                </span>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
          <div>
            <h4 className="font-bold text-[#3A3A3A] text-base mb-4">Redes Sociais</h4>
            <div className="flex gap-3">
              <a
                target="_blank"
                href="https://www.instagram.com/dra_mariescobar/"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 bg-white border border-[#DDE0D7] rounded-full flex items-center justify-center hover:bg-gradient-to-br hover:from-[#4F5D4A] hover:to-[#6B705C] hover:text-white hover:border-transparent transition-all duration-300 cursor-pointer text-[#6B705C]"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-[#DDE0D7] pt-8 text-center text-[#3A3A3A]/50 text-xs">
          <p>© {new Date().getFullYear()} Dra. Mariangela Escobar Gonçalves. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
}